import type { BackOffice, UpdateBackOfficePayload } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface BackOfficesResponse {
  back_offices: BackOffice[]
}

export function fetchBackOffices(context: ApiContext) {
  return apiContextFetch<BackOfficesResponse>(context, "back_offices")
}

export function fetchBackOffice(context: ApiContext, id: string) {
  return apiContextFetch<BackOffice>(context, `back_offices/${id}`)
}

export function updateBackOffice(context: ApiContext, id: string, payload: UpdateBackOfficePayload) {
  return apiContextFetch<BackOffice>(context, `back_offices/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ back_office: payload }),
  })
}
